export default __webpack_public_path__ + "static/media/whatsapp.305b200c.svg";